import { useState } from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

export interface DateRangeInputProps {
  lang: string;
  label: string;
  showLabel: boolean;
  onChange: (value: Value) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  name: string;
  'data-testid': string;
}

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

const DateRangeInput: React.FC<DateRangeInputProps> = ({
  lang,
  label,
  showLabel,
  onBlur,
  onFocus,
  name,
  onChange,
  'data-testid': testId,
}: DateRangeInputProps) => {
  const [value, setValue] = useState<Value>([null, null]);

  const handleChange = (newValue: Value) => {
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div className="date-field">
      <label
        className={`date-field ${showLabel ? 'show' : 'hide'}-label`}
        htmlFor={label}
      >
        {label}
      </label>
      <DateRangePicker
        onChange={handleChange}
        onBlur={onBlur}
        onFocus={onFocus}
        value={value}
        locale={lang}
        closeCalendar={true}
        calendarAriaLabel="Toggle calendar"
        clearAriaLabel="Clear value"
        dayAriaLabel="Day"
        monthAriaLabel="Month"
        nativeInputAriaLabel="Date"
        yearAriaLabel="Year"
        name={name}
        dayPlaceholder="dd"
        monthPlaceholder="mm"
        yearPlaceholder="yyyy"
        showLeadingZeros
        data-testid={testId}
      />
    </div>
  );
};

export default DateRangeInput;
